import OpenDataCarto from "./opendata-carto.js";

export function getCadastreLayer() {
    return new google.maps.ImageMapType({
        getTileUrl: (tileCoord, zoom) => {
            if (zoom > 19) {
                return null;
            }

            var url = "https://data.geopf.fr/wmts?SERVICE=WMTS&REQUEST=GetTile&VERSION=1.0.0" +
                    "&LAYER=CADASTRALPARCELS.PARCELLAIRE_EXPRESS" +
                    "&STYLE=normal"+
                    "&FORMAT=image/png"+
                    "&TILEMATRIXSET=PM"+
                    "&TILEMATRIX=" + zoom +
                    "&TILEROW="+ tileCoord.y +
                    "&TILECOL="+tileCoord.x;
            return url;
        },
        tileSize: new google.maps.Size(256, 256),
        name: "Cadastre",
        maxZoom: 19,
        minZoom: 0
    });
}

export function getPLULayer(map) {
    return new google.maps.ImageMapType({

        getTileUrl: (tileCoord, zoom) => {
            const tileSizeInPoints = 256 / Math.pow(2, zoom);

            const southWestPoint = {
                x: tileCoord.x * tileSizeInPoints,
                y: (tileCoord.y * tileSizeInPoints) + tileSizeInPoints
            }

            const northEastPoint = {
                x: (tileCoord.x * tileSizeInPoints) + tileSizeInPoints,
                y: tileCoord.y * tileSizeInPoints
            }

            const projection = map.getProjection();

            const southWestCoords = projection.fromPointToLatLng(southWestPoint);
            const northEastCoords = projection.fromPointToLatLng(northEastPoint);

            var url = "https://data.geopf.fr/wms-v/ows?"+
                "&LAYERS=zone_secteur" +
                "&FORMAT=image/png" +
                "&SERVICE=WMS"+
                "&VERSION=1.3.0"+
                "&REQUEST=GetMap"+
                "&STYLE=normal"+
                "&CRS=EPSG:4326" + 
                `&BBOX=${southWestCoords.lat()},${southWestCoords.lng()},${northEastCoords.lat()},${northEastCoords.lng()}`+
                `&WIDTH=${256}`+
                `&HEIGHT=${256}`;
            return url;
        },
        tileSize: new google.maps.Size(256, 256),
        name: "PLU",
        maxZoom: 21,
        minZoom: 0
    });
}

// Ajout du calque NATURA 2000
export function getNaturaLayer(map) {
    return new google.maps.ImageMapType({
        getTileUrl: (tileCoord, zoom) => {
            const tileSizeInPoints = 256 / Math.pow(2, zoom);

            const southWestPoint = {
                x: tileCoord.x * tileSizeInPoints,
                y: (tileCoord.y * tileSizeInPoints) + tileSizeInPoints
            };

            const northEastPoint = {
                x: (tileCoord.x * tileSizeInPoints) + tileSizeInPoints,
                y: tileCoord.y * tileSizeInPoints
            };

            const projection = map.getProjection();

            const southWestCoords = projection.fromPointToLatLng(southWestPoint);
            const northEastCoords = projection.fromPointToLatLng(northEastPoint);

            // Source : https://data.geopf.fr/wms/ + couche NATURA2000_SITES_POLYGON
            var url = "https://data.geopf.fr/wms?"+
                "&LAYERS=NATURA2000_SITES_POLYGON" +
                "&FORMAT=image/png" +
                "&SERVICE=WMS"+
                "&VERSION=1.3.0"+
                "&REQUEST=GetMap"+
                "&STYLE=default"+
                "&CRS=EPSG:4326" + 
                `&BBOX=${southWestCoords.lat()},${southWestCoords.lng()},${northEastCoords.lat()},${northEastCoords.lng()}`+
                `&WIDTH=256`+
                `&HEIGHT=256`;
            return url;
        },
        tileSize: new google.maps.Size(256, 256),
        name: "NATURA 2000",
        maxZoom: 21,
        minZoom: 0
    });
}

export function getOverlayControls(overlays, map) {
    const collapsibleMenu = document.createElement("div");
    collapsibleMenu.className = "menu";

    collapsibleMenu.innerHTML = `
        <a data-toggle="collapse" href="#overlayControls" role="button" aria-expanded="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-sliders" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M11.5 2a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM9.05 3a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0V3h9.05zM4.5 7a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM2.05 8a2.5 2.5 0 0 1 4.9 0H16v1H6.95a2.5 2.5 0 0 1-4.9 0H0V8h2.05zm9.45 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm-2.45 1a2.5 2.5 0 0 1 4.9 0H16v1h-2.05a2.5 2.5 0 0 1-4.9 0H0v-1h9.05z"/>
            </svg>
        </a>
    `;

    const div = document.createElement("div");
    div.id = "overlayControls";
    div.className = "collapse";
    collapsibleMenu.appendChild(div);

    for (let overlay in overlays) {
        const translation = trans.get(`common.carto.${overlay}`);
        const layer = overlays[overlay];

        div.insertAdjacentHTML('beforeend', `
            <div>
                <input type="checkbox" data-id="${overlay}"/>
                <label ${layer.color && 'style=color:' + layer.color}>${translation}</label>
                <input data-id="${overlay}" type="range" value="${(layer.opacity * 100) || 50}" min="0" max="100"/> 
            </div>
        `);

        const checkbox = div.querySelector(`input[type='checkbox'][data-id='${overlay}']`);

        const opacityInput = div.querySelector(`input[type='range'][data-id='${overlay}']`);

        const checkZoom = () => {
            checkbox.disabled = map.getZoom() < layer.minZoom;
            if (checkbox.disabled) {
                checkbox.title = trans.get(`common.carto.zoom_in`);
            } else {
                checkbox.title = "";
            }
        };

        checkZoom();
        google.maps.event.addListener(map, "zoom_changed", checkZoom);

        checkbox.onchange = (e) => {
            const displayLayer = e.target.checked;

            if (layer instanceof google.maps.ImageMapType) {
                if (displayLayer) {
                    map.overlayMapTypes.push(layer);
                    if (layer.maxZoom && layer.maxZoom < map.getZoom()) {
                        map.setZoom(layer.maxZoom);
                    }
                } else {
                    const index = map.overlayMapTypes.getArray().findIndex(e => e.name === layer.name);
                    map.overlayMapTypes.removeAt(index);
                }
            } else {
                if (displayLayer) {
                    layer.setMap(map)
                } else {
                    layer.hide();
                }
            }

            if (opacityInput) { 
                layer.setOpacity(opacityInput.value / 100);
            }
        }

        if (opacityInput && layer instanceof OpenDataCarto) {
            opacityInput.remove();
        } else if (opacityInput) {
            opacityInput.onchange = (e) => {
                const opacity = e.target.value;
                overlays[overlay].setOpacity(opacity / 100);
            }
        }
    }

    return collapsibleMenu;
}

export function getOverlayLegend() {
    const collapsibleLegend = document.createElement("div");
    collapsibleLegend.className = "legendecarte";

    collapsibleLegend.innerHTML = `
        <a data-toggle="collapse" href="#overlayLegend" role="button" aria-expanded="false">
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor">
                <rect x="0" y="0" rx="2" ry="6" width="32" height="32"/>
                <text x="12" y="26" fill="white" font-size="2em">i</text>
            </svg>
        </a>
    `;

    const div = document.createElement("div");
    div.id = "overlayLegend";
    div.className = "collapse";
    collapsibleLegend.appendChild(div);

    var listItemsLegende = ['opportunite', 'opportuniteAction', 'enEtude', 'enTravaux', 'exploit', 'annule'];

    listItemsLegende.forEach(function(itemLegende) {
        var translation = trans.get(`common.carto.${itemLegende}`);

        var nomImg;
        switch(itemLegende) {
            case 'opportunite':
                nomImg = 'a';
                break;
            case 'opportuniteAction' : 
                nomImg = 'a1';
                break;
            case 'enEtude' :
                nomImg = 'b';
                break;
            case 'enTravaux' :
                nomImg = 'c' ;
                break;
            case 'exploit' :
                nomImg = 'd';
                break;
            case 'annule' :
                nomImg = 'e';
                break;
            default :
                nomImg = 'a';
                break;
        }
        const cheminImg = '/image/maps/'+ nomImg + '.png';

        div.insertAdjacentHTML('beforeend', `
            <div>
                <input type="image" id="imgLegende${itemLegende}" alt="${itemLegende}" src="${cheminImg}"/>
                <label>${translation}</label> 
            </div>
        `);

    });

    return collapsibleLegend;
}
/*
export function getCheminImageLegende(itemLegende) {
    return '/image/maps/' + getNomFichierImageLegende(itemLegende) + '.png';
}

export function getNomFichierImageLegende(itemLegende) {
    switch(itemLegende) {
        case 'opportunite':
            return 'a';
        case 'opportuniteAction' : 
            return 'a1';
        case 'enEtude' :
            return 'b';
        case 'enTravaux' :
            return 'c' ;
        case 'exploit' :
            return 'd';
        case 'annule' :
            return 'e';
        default :
            return 'a';
    }
}*/